import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap CSS
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Bootstrap JS
import { FaBars, FaTimes } from 'react-icons/fa'; // Import React Icons

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <nav
            className={`navbar navbar-expand-lg fixed-top pb-md-4 ${
                scrolled ? 'navbar-scrolled' : 'navbar-transparent'
            }`}
        >
            <div className="container">
                <a className="navbar-brand" href="#">
                    <img src="../images/logo-light.png" alt="Logo" className="navbar-logo" />
                </a>
                {/* Menu Button */}
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasNavbar"
                    aria-controls="offcanvasNavbar"
                >
                    <FaBars className="text-white fa-bars-icon" />
                </button>
                <div
                    className="offcanvas offcanvas-end"
                    tabIndex="-1"
                    id="offcanvasNavbar"
                    aria-labelledby="offcanvasNavbarLabel"
                >
                    <div className="offcanvas-header">
                        <h5 className="offcanvas-title text-light" id="offcanvasNavbarLabel">Menu</h5>
                        {/* Close Button */}
                        <button
                            type="button"
                            className="close-btn text-reset"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        >
                            <FaTimes className="text-white fa-close-icon" />
                        </button>
                    </div>
                    <div className="offcanvas-body">
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <a className="nav-link" href="#home">Features</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#about">About</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#dashboard">Dashboard</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#Services">Services</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link signup-link" href="#pricing">Pricing</a>
                            </li>
                            <div className="navbar-buttons d-flex flex-column flex-md-row mt-4">
                                <button className="btn btn-outline-light btn-1 mb-2 mb-md-0">Free Trial</button>
                                <button className="btn btn-2 ms-md-4">Schedule a Demo</button>
                            </div>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
